import * as React from "react"
import { MainNav } from "@/components/MainNav"
import { GlassPanel } from "@/components/ui/glass-panel"

export function AppShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative flex min-h-dvh overflow-hidden bg-muted/45 text-foreground">
      <div className="pointer-events-none fixed -right-40 -top-48 size-[38rem] rounded-full bg-primary/14 blur-[130px]" />
      <div className="pointer-events-none fixed inset-0 opacity-25 [background-image:linear-gradient(to_right,var(--border)_1px,transparent_1px),linear-gradient(to_bottom,var(--border)_1px,transparent_1px)] [background-size:4rem_4rem] [mask-image:radial-gradient(circle_at_70%_10%,black,transparent_72%)]" />
      <a className="skip-link" href="#main-content" onClick={() => document.getElementById("main-content")?.focus()}>Skip to main content</a>
      <MainNav />
      <main id="main-content" tabIndex={-1} className="relative min-w-0 flex-1 px-3 pb-[max(1rem,env(safe-area-inset-bottom))] pt-16 outline-none print:px-0 print:py-0 sm:px-5 lg:p-4">
        <GlassPanel className="mx-auto min-h-[calc(100dvh-2rem)] max-w-[92rem] p-4 print:max-w-none print:border-0 print:bg-background print:p-0 print:shadow-none sm:p-7 lg:p-9">{children}</GlassPanel>
      </main>
    </div>
  )
}
